import { trpc } from '@/shared/api';

interface InvalidateNotifications {
  /** 발송 이력(모든 조건의 목록)을 다시 불러온다 — 재발송 뒤 새 "대기" 행이 보이게 한다. */
  readonly invalidateDeliveries: () => Promise<void>;
  /** 알림 설정(유형별 ON/OFF·운영자 수신자)을 다시 불러온다. */
  readonly invalidateSettings: () => Promise<void>;
}

/**
 * 어드민 알림 캐시 갱신 — 발송 이력·알림 설정 무효화를 한곳에 모은다. 무효화는 재조회 promise 를 돌려준다.
 * 쓰기 훅이 이 promise 를 기다리면 새 목록이 오기 전에 버튼이 풀리지 않는다.
 */
export const useInvalidateNotifications = (): InvalidateNotifications => {
  const utils = trpc.useUtils();

  return {
    invalidateDeliveries: () => utils.notificationManagement.listDeliveries.invalidate(),
    invalidateSettings: () => utils.notificationManagement.getSettings.invalidate(),
  };
};
